import axios from 'axios'
import redirectToLogin from './redirect'

let workspaceID
let api

export function getWorkspaceAPI (id) {
  return axios.create({
    baseURL: getBaseURL(id)
  })
}

export function setup (id) {
  // set singleton vars
  workspaceID = id
  api = getWorkspaceAPI(id)
  api.interceptors.response.use(function (response) {
    if (response.status !== 401) return response
    redirectToLogin()
  })

  window.api = api
}

export function fetch (...args) {
  return api(...args)
}

export async function fetchJSON (...args) {
  const r = await api(...args)
  return r.data
}

fetchJSON.post = async function (...args) {
  const r = await api.post(...args)
  return r.data
}

export default function () {
  return api
}

export function getBaseURL (id = workspaceID) {
  if (!id) throw new Error('getBaseURL – workspaceID not set')
  return `/api/workspaces/${id}`
}



// WEBPACK FOOTER //
// ../webmango-core/api.js